import React from 'react';
import { MainView, BuildSkillBox, BSBreakDown  } from '../components/components.js';

class BuildSkills extends React.Component {


	constructor(props) {
		super(props);

		this.getBuildSkillsData = this.getBuildSkillsData.bind(this);

		this.state = {
			skills : {
				data : {},
				dataError: false
			}
		};
	}

	componentDidMount() {
		if(Object.keys(this.state.skills.data).length === 0 && this.state.skills.dataError === false) {
			this.getBuildSkillsData();
		}
	}


	getBuildSkillsData() {
		var component = this;

		var callback = function(response) {
			if(response.detail !== "Report generated") {
				component.setState({skills : {data: response.data, dataError : response.detail}});
			}
			else {
				
				component.setState({skills : {data : response.data, dataError: false}});
			}
		};

		window._fiSponsor.getBuildSkillsData(callback);
	}

	render() {
		if(!window._fiSponsor.sponsors.length) {
			window._fiSponsor.loadSessionInfo();
		}

		var boxSize = {
			width: '33vmin',
			height: '35vmin'
		};
		var content = (
			<div className='BuildSkills'>
				{'Loading data...'}
			</div>
			);

		if(Object.keys(this.state.skills.data).length && !this.state.skills.dataError) {
			var contentArray = [];
			var rowArray = [];
			var total_impressions = 0, total_paid = 0.0;

			for(var i = 0; i !== this.state.skills.data.length; ++i) {
				var skill = this.state.skills.data[i];

				if(window.app.version.indexOf('demo') > -1 && (parseFloat(skill.earned) / parseFloat(skill.total_users)) > 0.1) {
					skill.earned = (parseFloat(skill.total_users) * 0.1).toFixed(2).toString();
				}

				total_impressions += parseFloat(skill.total_users);
				total_paid += parseFloat(skill.earned);

				var skillJSX = (
					<BuildSkillBox key={'BuildSkillBox-' + i} size={boxSize} 
						numOfSkills={skill.total_skills} 
						numCompleted={skill.total_payouts} 
						numUsers={skill.total_users}
						numLikes={skill.total_rating}
						rewardsPaid={skill.earned}
						title={skill.label}
						icon={process.env.PUBLIC_URL + "images/BuildSkills_" + skill.label.replace(/\W/g, '') + ".png"}
					/>
				);

				rowArray.push(skillJSX);

				if(rowArray.length >= 3 || i === this.state.skills.data.length - 1) {
					contentArray.push(
						(
							<div key={'BuildSkillRow-' + contentArray.length} className='BuildSkills-Row'>
								{rowArray}
							</div>

						)
					);
					rowArray = [];
				}

			}

			total_paid = total_paid.toFixed(2);
			content = (
				<div className='BuildSkills'>
					<BSBreakDown total_spent={total_paid}  total_impressions={total_impressions} />
					{contentArray}
				</div>
			);
		}

		return (
			<MainView location={["Dashboard", "Build Skills"]} amount={window._fiSponsor.sponsors[0].total_saved} content={content} />
		);
  	}
}


export default BuildSkills;